import React from 'react';

import GeneralDecisionForm from './GeneralDecisionForm';

import LoadingSpinner from 'CommonComponents/LoadingSpinner';
import Modal from 'CommonComponents/Modal';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function GeneralDecisionUpsertModal(props) {
    const close = () => {
        props.onClose();
        props.modal.hide();
    };

    const onCreated = () => {
        close();
        props.onCreated();
    };

    return (
        <Modal id={props.id} modal={props.modal}>
            <ModalHeader
                title={props.decision ? $t('Edit {{name}}', { name: props.decision.description }) : $t('Add New Decision')}
                close={close}
            ></ModalHeader>
            <div className="tw-rounded-b">
                {props.isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <div className="modal__form-container">
                        <GeneralDecisionForm
                            currentVenue={props.currentVenue}
                            allowVenueSelection={props.allowVenueSelection}
                            datasets={props.datasets}
                            storeUrl={props.storeUrl}
                            updateUrl={props.updateUrl}
                            decision={props.decision}
                            onSuccess={onCreated}
                            onCancel={close}
                        />
                    </div>
                )}
            </div>
        </Modal>
    );
}
